module.exports = __webpack_public_path__ + "img/indicador_clima_hover.e6e88995.png";